import { createBrowserHistory, createHashHistory } from 'history'
import { Provider } from 'react-redux'
import { Router } from 'react-router'
import { StylesAsDataAttributes } from 'substyle-glamor'

import {
  CSSVariablesProvider,
  ErrorBoundary,
  UI5Theme,
} from '@signavio/effektif-commons'

import { ThemeProvider, fioriTheme } from '@signavio/ui'

import store from '../store'
import Routes from './Routes'
import { StrictMode } from 'react'

export { default as store } from '../store'

// @ts-ignore TS complains that push state is always defined.
// But in case with SSR this is not true
const createHistory = window.history.pushState
  ? createBrowserHistory
  : createHashHistory

export const history = createHistory()

export default function SignavioWorkflowPublicForms() {
  return (
    <UI5Theme>
      <StylesAsDataAttributes>
        <ThemeProvider theme={fioriTheme}>
          <CSSVariablesProvider>
            <Provider store={store}>
              <Router history={history}>
                <ErrorBoundary>
                  {process.env.REACT_STRICT_MODE ? (
                    <StrictMode>
                      <Routes />
                    </StrictMode>
                  ) : (
                    <Routes />
                  )}
                </ErrorBoundary>
              </Router>
            </Provider>
          </CSSVariablesProvider>
        </ThemeProvider>
      </StylesAsDataAttributes>
    </UI5Theme>
  )
}
